import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'
import { useDebounce } from 'stimulus-use'

export class ComboboxController extends Controller<HTMLDivElement> {
  static debounces = ['inputChangedHandler']

  static targets = ['input']

  static values = {
    id: String,
  }

  declare readonly inputTarget: HTMLInputElement
  declare idValue: string

  connect(): void {
    useDebounce(this, { wait: 300 })

    this.inputTarget.addEventListener('input', this.inputChangedHandler)
  }

  disconnect(): void {
    this.inputTarget.removeEventListener('input', this.inputChangedHandler)
  }

  private inputChangedHandler = (event: Event): void => {
    this.getSearchResults((event.target as HTMLInputElement).value)
  }

  private async getSearchResults(term: string) {
    try {
      await get('/members/search', {
        query: {
          q: term,
          target: this.idValue,
        },
        responseKind: 'turbo-stream',
      })
    } catch (error) {
      console.error(error)
    }
  }
}
